// extracted by mini-css-extract-plugin
export default {"link":"QO-z","disabled":"RO-z"};